import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { UserAccount } from "src/app/shared/models/user-account";

import { AuthService } from "../service/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  userAccount: UserAccount;
  constructor(private authService: AuthService, private router: Router) {
    this.userAccount = new UserAccount();
  }
  ngOnInit() {
    this.userAccount = JSON.parse(sessionStorage.getItem("CurrentUser"));
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (sessionStorage.getItem("CurrentUser") != null) {
      // if (this.userAccount) {
      //   this.router.navigate(["/authentication/signin"]);
      //   return false;
      // }
      return true;
    }
    this.router.navigate(["/authentication/signin"]);
    return false;
  }

  // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  //   if (this.authService.currentUserValue) {
  //     const userRole = this.authService.currentUserValue.role;
  //     if (route.data.role && route.data.role.indexOf(userRole) === -1) {
  //       this.router.navigate(['/authentication/signin']);
  //       return false;
  //     }
  //     return true;
  //   }

  //   this.router.navigate(['/authentication/signin']);
  //   return false;
  // }
}
